import * as Hogan from 'hogan.js';
import Cookie from 'js-cookie';


;(function( $, window, document, undefined ){

  var Messaging = function( elem, options ){
    this.elem = $.grep(elem, function(el) {
      return $(el).data('load') ? true : false;
    });

    this.$elem = $(this.elem);
    this.options = options;

    this.metadata = this.$elem.data( 'plugin-options' );

    this._init = false;
    this.cache_timeout = 30 * 60 * 1000; // 30 mins

    if (this.$elem.length === 0) {
      //no elements to bind to...don't setup messaging.
      this._init = true;
    }
  };

  // the plugin prototype
  Messaging.prototype = {
    defaults: {
      message: 'Messaging Enabled'
    },

    templates: {
      message:   "{{#messages}}" +
                   "<div role='alert' aria-labelledby='adafruit-message-{{msgid}}' class='messaging-container messaging-{{type}}'>" +
                     "<div class='msg-container'>" +
                       "<div id='adafruit-message-{{msgid}}' class='message' data-message-id='{{msgid}}'>{{{message}}}</div>" +
                       "{{#dismissable}}" +
                         "<i class='fa fa-times msg-close-btn'></i>" +
                       "{{/dismissable}}" +
                     "</div>" +
                   "</div>" +
                 "{{/messages}}"
    },

    init: function() {
      if (this._init) {
        return;
      }

      this._init = true;

      // Introduce defaults that can be extended either
      // globally or using an object literal.
      this.config = $.extend({}, this.defaults, this.options, this.metadata);

      this.render_message(this.$elem);
      this.handle_close(this.$elem);

      return this;
    },

    load_messaging: function($el) {

      var promise = $.Deferred(),
          path = $el.data('load'),
          cached;

      // the element should have a data-load property set
      if(! path)
        return promise.reject();

      // return sessionStorage cache if present
      if(sessionStorage && (cached = sessionStorage.getItem('cache-' + path))) {

        try {

          cached = JSON.parse(cached);

          if(cached.timestamp && Date.now() < cached.timestamp) {
            return promise.resolve(cached.data);
          }

        } catch(e) {}

      }

      // make a request for the message if needed
      $.getJSON(path).then(function(data) {

        // cache the message in session storage
        if(sessionStorage) {
          sessionStorage.setItem('cache-' + path, JSON.stringify({
            timestamp: Date.now() + this.cache_timeout,
            data: data
          }));
        }

        promise.resolve(data);

      }.bind(this));

      return promise;

    },

    process_for_display: function(data) {
      return data.filter(function(msg) {
        var name = "seen_msg_" + msg.msgid;

        return Cookie.get(name) !== "1";
      });
    },

    process_for_dismissable: function(data) {
      return data.map(function(msg) {
        return { dismissable: true, ...msg };
      });
    },

    render_message: function($el) {

      var promise = $.Deferred();
      var message_template = Hogan.compile(this.templates.message);

      this.load_messaging($el).then(function(data) {
        data = this.process_for_display(data);

        // ensure dismissable is set by default
        data = this.process_for_dismissable(data);

        $el.html(message_template.render({"messages": data}));

        promise.resolve();
      }.bind(this));

      return promise;

    },

    handle_close: function($el) {
      $el.on('click', '.msg-close-btn', function(event) {
        var separate = window.location.hostname.split('.');
        separate.shift();
        var domain = "." + separate.join('.');
        var id = $(this).siblings('.message').data('message-id');

        $('.messaging-container').hide();

        document.cookie = "seen_msg_" + id + "=1; path=/;domain=" + domain + " ;";
      });
    }
  };

  Messaging.defaults = Messaging.prototype.defaults;

  $.fn.adafruit_messaging = function(options) {
    return new Messaging(this, options).init();
  };

})( jQuery, window , document );
